import { darken_colors } from 'z3k-settings/components/utils/ColorPicker4bit';
import { requestDeviceUpdate } from 'console/redux/devices/items/actions';
const economy_color = darken_colors[4];
const comfort_color = darken_colors[12];
const shedule_color = darken_colors[7];
const off_color = darken_colors[14];
const legacy_heating_modes_colors = [
    economy_color,
    comfort_color,
    shedule_color,
    off_color,
];
export function getLegacyHeatingModes(device) {
    const { id: device_id, thermostat_ext_modes_config } = device;
    const heating_modes = Object.entries(thermostat_ext_modes_config || {});
    const shared_heating_modes = heating_modes.map(([mode_id, mode_spec], index) => {
        const { zone_temp, name, active: mode_active, hidden, schedule_number, } = mode_spec;
        const is_hidden = !mode_active || hidden;
        if (is_hidden) {
            return null;
        }
        const id = Number(mode_id);
        const temperature = zone_temp &&
            typeof zone_temp[1] !== 'string' &&
            typeof zone_temp[1] !== 'undefined'
            ? Number(zone_temp[1])
            : undefined;
        const onSelectMode = () => requestDeviceUpdate(device_id, {
            thermostat_ext_mode: id,
            thermostat_gate: false,
        }, { ignore_server_response: true, obey_only_last_response: true }, id);
        const color = legacy_heating_modes_colors[index];
        return {
            id,
            name,
            is_hidden,
            temperature,
            color,
            onSelectMode,
            schedule_number,
        };
    });
    return shared_heating_modes;
}
